module.exports = __webpack_public_path__ + "../resources/img/ic_wifi_on.478bf9ac.svg";